import { render } from "./GridIndemnizatii.vue?vue&type=template&id=087ee206&ts=true"
import script from "./GridIndemnizatii.vue?vue&type=script&lang=ts"
export * from "./GridIndemnizatii.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__